import React, { useState, useContext } from 'react';
import CollapseDoQuestionario from '../CollapseDoQuestionario';
import GrupoDeBotoesRadio from '../GrupoDeBotoesRadio';
import { IGrupoDePerguntas } from '../../interfaces/IResponderFormularioResponse';
import CampoDeObservacao from '../CampoDeObservacao';
import CampoDeAnotacao from '../CampoDeAnotacao';
import CampoDeAnexoDeEvidencia from '../CampoDeAnexoDeEvidencia';
import CampoDePreenchimentoDeAcao from '../CampoDePreenchimentoDeAcao';
import CampoDeAnexoDeImagens from '../CampoDeAnexoDeImagens';
import { Tooltip } from 'react-tippy';
import { LanguageContext } from '../../../../../context/LanguageContext';
import { ResponderFormularioContext } from '../../contexts/ResponderFormularioContext';

interface IProps {
    grupoDePerguntas: IGrupoDePerguntas[];
    chaveDoObjeto: string;
    permitirEditarRespostas: boolean;
    permitirEditarAcoes: boolean;
    permitirCompartilhar: boolean;
}

enum CampoDePreenchimento {
    Observacao,
    Anotacao,
    Acoes,
}

enum CampoDeAnexo {
    Imagem,
    Evidencia,
}

const QuestionarioRecursivo = ({ grupoDePerguntas, chaveDoObjeto, permitirEditarRespostas, permitirEditarAcoes, permitirCompartilhar }: IProps): any => {
    const grupoDePerguntasTemConteudo = grupoDePerguntas && grupoDePerguntas.length > 0;
    const { getLanguageResource } = useContext(LanguageContext);
    const { responderFormulario } = useContext(ResponderFormularioContext);
    const [campoDePreenchimentoAtivo, setCampoDePreenchimentoAtivo] = useState<Record<number, CampoDePreenchimento | null>>({});
    const [campoDeAnexoAtivo, setCampoDeAnexoAtivo] = useState<Record<number, CampoDeAnexo | null>>({});

    const handleClickTabs = (event: React.MouseEvent<HTMLAnchorElement>, perguntaId: number): void => {
        event.preventDefault();
        const textoDoLink = event.currentTarget.textContent;
        const campoAtualDaPergunta = campoDePreenchimentoAtivo[perguntaId];

        if (textoDoLink === getLanguageResource('observation') && campoAtualDaPergunta === CampoDePreenchimento.Observacao) {
            setCampoDePreenchimentoAtivo(prev => ({ ...prev, [perguntaId]: null }));
            return;
        } else if (textoDoLink === getLanguageResource('annotation') && campoAtualDaPergunta === CampoDePreenchimento.Anotacao) {
            setCampoDePreenchimentoAtivo(prev => ({ ...prev, [perguntaId]: null }));
            return;
        } else if (textoDoLink === getLanguageResource('actions') && campoAtualDaPergunta === CampoDePreenchimento.Acoes) {
            setCampoDePreenchimentoAtivo(prev => ({ ...prev, [perguntaId]: null }));
            return;
        }

        if (textoDoLink === getLanguageResource('observation')) {
            setCampoDePreenchimentoAtivo(prev => ({ ...prev, [perguntaId]: CampoDePreenchimento.Observacao }));
        } else if (textoDoLink === getLanguageResource('annotation')) {
            setCampoDePreenchimentoAtivo(prev => ({ ...prev, [perguntaId]: CampoDePreenchimento.Anotacao }));
        } else if (textoDoLink === getLanguageResource('actions')) {
            setCampoDePreenchimentoAtivo(prev => ({ ...prev, [perguntaId]: CampoDePreenchimento.Acoes }));
        }
    }

    const handleAttachmentFieldsButtons = (event: React.MouseEvent<HTMLButtonElement>, perguntaId: number): void => {
        event.preventDefault();
        const iconeClicado = event.currentTarget.querySelector('i')?.classList[1];
        const campoAnexoAtualDaPergunta = campoDeAnexoAtivo[perguntaId];

        if (iconeClicado === 'bi-paperclip' && campoAnexoAtualDaPergunta === CampoDeAnexo.Evidencia) {
            setCampoDeAnexoAtivo(prev => ({ ...prev, [perguntaId]: null }));
            return;
        } else if (iconeClicado === 'bi-camera' && campoAnexoAtualDaPergunta === CampoDeAnexo.Imagem) {
            setCampoDeAnexoAtivo(prev => ({ ...prev, [perguntaId]: null }));
            return;
        }

        if (iconeClicado === 'bi-paperclip') {
            setCampoDeAnexoAtivo(prev => ({ ...prev, [perguntaId]: CampoDeAnexo.Evidencia }));
        } else if (iconeClicado === 'bi-camera') {
            setCampoDeAnexoAtivo(prev => ({ ...prev, [perguntaId]: CampoDeAnexo.Imagem }));
        }
    }

    if (grupoDePerguntasTemConteudo) {
        return grupoDePerguntas.sort((a, b) => {
            if (a.ordenacao !== b.ordenacao) {
                return a.ordenacao - b.ordenacao;
            }

            return a.nome.localeCompare(b.nome);
        })
            .map((item) => {
                if (item.setores) {
                    const temSetorEmComum = item.setores.some(setor =>
                        responderFormulario.setoresDoUsuario.includes(setor.id)
                    );

                    if (!temSetorEmComum) {
                        return null;
                    }
                }

                return (
                    <CollapseDoQuestionario
                        titulo={item.nome}
                        key={item.id}
                        id={`grupo-de-perguntas-${item.id}`}
                    >
                        <div className='ml-0 ml-md-3'>
                            {
                                item.perguntas.map(pergunta => (
                                    <div className='mb-3 px-3 pt-1 rounded border'>

                                        <div className='border-bottom d-flex flex-row justify-content-between my-3 px-1'>
                                            <div className='d-flex flex-column'>
                                                <h5>{pergunta.tituloDaPergunta}</h5>
                                                {
                                                    pergunta.textoDeAjuda && pergunta.textoDeAjuda.length > 0
                                                        ? (
                                                            <Tooltip
                                                                html={
                                                                    <div className='d-flex flex-column p-1'>
                                                                        <strong className='border-bottom'>{getLanguageResource('help')}</strong>
                                                                        <div className='mt-2' style={{ whiteSpace: 'pre-line', background: '#' }}>
                                                                            {pergunta.textoDeAjuda}
                                                                        </div>
                                                                    </div>
                                                                }
                                                                arrow
                                                                interactive
                                                                delay={500}
                                                            >
                                                                <i className='bi bi-info-circle-fill text-primary ml-2' />
                                                            </Tooltip>
                                                        )
                                                        : <React.Fragment />
                                                }
                                            </div>

                                            <div className='px-4'>
                                                <div className='d-flex w-100 justify-content-center'>
                                                    {
                                                        pergunta.permitirAnexarEvidencia && (
                                                            <button className='btn btn-primary rounded-circle mr-1 mb-1 d-flex align-items-center justify-content-center p-2' type='button' onClick={(e) => handleAttachmentFieldsButtons(e, pergunta.id)}><i style={{ fontSize: '1.5rem' }} className="bi bi-paperclip" /></button>
                                                        )
                                                    }
                                                    {
                                                        pergunta.permitirAnexarImagem && (
                                                            <button className='btn btn-primary rounded-circle mb-1 d-flex align-items-center justify-content-center p-2' type='button' onClick={(e) => handleAttachmentFieldsButtons(e, pergunta.id)}><i style={{ fontSize: '1.5rem' }} className="bi bi-camera" /></button>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ whiteSpace: 'pre-line' }}><i>{pergunta.descricao}</i></div>

                                        <div>
                                            <GrupoDeBotoesRadio idDaPergunta={pergunta.id} permitirEditar={permitirEditarRespostas || permitirCompartilhar} />
                                        </div>

                                        <div className='row mt-4 px-0'>
                                            <ul className="nav nav-tabs w-100">
                                                {
                                                    pergunta.permitirObservacao && (
                                                        <li className="nav-item">
                                                            <a className={`text-dark nav-link ${campoDePreenchimentoAtivo[pergunta.id] === CampoDePreenchimento.Observacao ? "active" : ""}`} href="/" onClick={(e) => handleClickTabs(e, pergunta.id)}>{getLanguageResource('observation')}</a>
                                                        </li>
                                                    )
                                                }
                                                {
                                                    pergunta.permitirAnotacao && (
                                                        <li className="nav-item">
                                                            <a className={`text-dark nav-link ${campoDePreenchimentoAtivo[pergunta.id] === CampoDePreenchimento.Anotacao ? "active" : ""}`} href="/" onClick={(e) => handleClickTabs(e, pergunta.id)}>{getLanguageResource('annotation')}</a>
                                                        </li>
                                                    )
                                                }
                                                {
                                                    pergunta.permitirPlanoDeAcao && pergunta.acoes[0].campoDasAcoes.length > 0 && (
                                                        <li className="nav-item">
                                                            <a className={`text-dark nav-link ${campoDePreenchimentoAtivo[pergunta.id] === CampoDePreenchimento.Acoes ? "active" : ""}`} href="/" onClick={(e) => handleClickTabs(e, pergunta.id)}>{getLanguageResource('actions')}</a>
                                                        </li>
                                                    )
                                                }
                                            </ul>
                                            {
                                                pergunta.permitirObservacao && campoDePreenchimentoAtivo[pergunta.id] === CampoDePreenchimento.Observacao
                                                    ? <CampoDeObservacao idDaPergunta={pergunta.id} observacao={pergunta.observacao} />
                                                    : <React.Fragment />
                                            }

                                            {
                                                pergunta.permitirAnotacao && campoDePreenchimentoAtivo[pergunta.id] === CampoDePreenchimento.Anotacao
                                                    ? <CampoDeAnotacao idDaPergunta={pergunta.id} anotacao={pergunta.anotacao} anotacoes={pergunta.anotacoes} />
                                                    : <React.Fragment />
                                            }

                                            {
                                                pergunta.permitirPlanoDeAcao && pergunta.acoes[0].campoDasAcoes.length > 0 && campoDePreenchimentoAtivo[pergunta.id] === CampoDePreenchimento.Acoes
                                                    ? <CampoDePreenchimentoDeAcao pergunta={pergunta} permitirEditar={permitirEditarAcoes || permitirCompartilhar} />
                                                    : <React.Fragment />
                                            }
                                            {
                                                pergunta.permitirAnexarImagem && campoDeAnexoAtivo[pergunta.id] === CampoDeAnexo.Imagem
                                                    ? <CampoDeAnexoDeImagens pergunta={pergunta} />
                                                    : <React.Fragment />
                                            }

                                            {
                                                pergunta.permitirAnexarEvidencia && campoDeAnexoAtivo[pergunta.id] === CampoDeAnexo.Evidencia
                                                    ? <CampoDeAnexoDeEvidencia idDaPergunta={pergunta.id} evidenciasAnexadas={pergunta.evidenciaAnexada} />
                                                    : <React.Fragment />
                                            }
                                        </div>
                                    </div>
                                ))
                            }
                            <QuestionarioRecursivo
                                grupoDePerguntas={item[chaveDoObjeto]}
                                chaveDoObjeto={chaveDoObjeto}
                                permitirEditarRespostas={permitirEditarRespostas}
                                permitirEditarAcoes={permitirEditarAcoes}
                                permitirCompartilhar={permitirCompartilhar}
                            />
                        </div>
                    </CollapseDoQuestionario>
                )
            })
    }

    return <React.Fragment />;
}

export default QuestionarioRecursivo;
